
export default [
  //佣金管理
  {
    path: '/lirun',
    component: () => import('@/views/lirun/shijianchaxun/index'),
    redirect: '/lirun/shijianchaxun/wode',
    children: [

      {
        path: '/lirun/shijianchaxun/wode',
        component: () => import('@/views/lirun/shijianchaxun/wode'),
        mete: {
          title: "按照时间罗列",
        },
      }

    ]
  },
  {
    path: '/lirun/yongjinbaobiao',
    component: () => import('@/views/lirun/yongjinbaobiao/index'),
    redirect: '/lirun/yongjinbaobiao/wode',
    children: [

      {
        path: '/lirun/yongjinbaobiao/wode',
        component: () => import('@/views/lirun/yongjinbaobiao/wode'),
        mete: {
          title: "商品佣金报表",
        },
      }

    ]
  },
  {
    path: '/lirun/xiazai',
    component: () => import('@/views/lirun/xiazai/index'),
    redirect: '/lirun/xiazai/wode',
    children: [

      {
        path: '/lirun/xiazai/wode',
        component: () => import('@/views/lirun/xiazai/wode'),
        mete: {
          title: "下载",
        },
      }

    ]
  },
  {
    path: '/lirun/lirunbaobiao',
    component: () => import('@/views/lirun/lirunbaobiao/index'),
    redirect: '/lirun/lirunbaobiao/wode',
    children: [

      {
        path: '/lirun/lirunbaobiao/wode',
        component: () => import('@/views/lirun/lirunbaobiao/wode'),
        mete: {
          title: "利润报表",
        },
      },
      {
        path: '/lirun/lirunbaobiao/anriqi',
        component: () => import('@/views/lirun/lirunbaobiao/anriqi'),
        mete: {
          title: "利润报表_按时间",
        },
      }

    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/lirun.js